import SchemaOrg from '@/components/base/SchemaOrg';
import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import CategoryDropdown from './components/CategoryDropdown';
import CategoryGrid from './components/CategoryGrid';
import SeoContent from './components/SeoContent';
import Footer from './components/Footer';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Superbuy Sheet',
  url: 'https://superbuysheet.click',
  description: 'Your ultimate shopping discovery platform featuring curated product categories, expert guides, and shopping tips for smarter online browsing in 2026.',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://superbuysheet.click/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Superbuy Sheet',
  url: 'https://superbuysheet.click',
  description: 'An independent shopping discovery and educational platform helping shoppers navigate curated product categories with expert guides and organized resources.',
  logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/67defc9f4dfae2c04004e8ea78b88107.png',
};

export default function Home() {
  return (
    <>
      <SchemaOrg data={websiteSchema} />
      <SchemaOrg data={organizationSchema} />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryDropdown />
        <CategoryGrid />
        <SeoContent />
      </main>
      <Footer />
    </>
  );
}